import {ReactNode, useEffect, useMemo, useRef} from 'react'
import WizTable from '../../components/table/TableFactory'
import Text from '../../components/text/Text'
import {ComponentItem, CreateComponent} from '../../components/useComponent'
import useQueryDevServer from '../../hooks/api/dashboard/useQueryDevServer'
import PageLayout from '../../components/layout/PageLayout'
import {useTime} from '../../utils/time'
import WizTag from '../../components/tag/WizTag'
import copyToClipBoard from '../../utils/clipBoard'
import WizButton from '../../components/button/WizButton'
import DeleteDevservernModal from './devServerDeleteModal'

interface IProps {
    className?: string
}

const DevServer: React.FC<IProps> = ({className}) => {
    const {data, refetch} = useQueryDevServer()
    const headerTitles: string[] = ['status', 'Branch', 'Mongo', 'Mysql', 'CreatedAt', '']
    const {convertUtc0ToUtc9} = useTime()

    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))

    const deleteDevserverRef = useRef<any>()

    const handleInactiveButton = (branch: string) => {
        deleteDevserverRef?.current?.show(branch)
    }

    const devServerList = useMemo(() => {
        if (data === undefined || data?.length === 0) {
            return []
        }
        return data.map<ReactNode[]>(el => [
            <WizTag state={el.status === 'active' ? true : false}>{el.status}</WizTag>,
            <div
                className={'space-y-[5px] reak-words whitespace-normal'}
                onClick={() => copyToClipBoard(`apitest.leagueoftraders.io/lot${el.branch}`)}>
                {CreateComponent(Text, {children: el.branch})}
            </div>,
            <div
                className={'space-y-[5px] reak-words whitespace-normal'}
                onClick={() =>
                    copyToClipBoard(
                        `mongodb://root:password@apitest.leagueoftraders.io:${el.mongo_port}/lot?authSource=admin`,
                    )
                }>
                {CreateComponent(Text, {children: el.mongo_port})}
            </div>,
            <div
                className={'space-y-[5px] reak-words whitespace-norma'}
                onClick={() =>
                    copyToClipBoard(
                        `jdbc:mysql://apitest.leagueoftraders.io:${el.mysql_port}/lot?paaword=pass&user=root`,
                    )
                }>
                {CreateComponent(Text, {children: el.mysql_port})}
            </div>,
            <div className={'space-y-[5px] reak-words whitespace-normal max-w-xl'}>
                {CreateComponent(Text, {children: convertUtc0ToUtc9(el.created_at)})}
            </div>,
            <WizButton
                className={el.status !== 'active' ? 'hidden' : ''}
                type="red"
                size="small"
                text="Close by Self"
                onClick={() => handleInactiveButton(el.branch)}
            />,
        ])
    }, [data])

    useEffect(() => {
        refetch()
    }, [])

    return (
        <PageLayout title={'backend dev server'} className="block">
            <WizTable gridCols={'7'} className="w-full" headers={headers} items={devServerList} />
            <DeleteDevservernModal ref={deleteDevserverRef} />
        </PageLayout>
    )
}

export default DevServer
